//------------------- Start External Library Import -------------------------------------//
import React, { lazy } from "react";
import { Route, Redirect } from "react-router-dom";
//------------------- Start External Library Import -------------------------------------//

//------------------- Start Page Import -------------------------------------//
const DashboardTab = lazy(() => import("../pages/dashboardtab"));

const Cards = lazy(() => import("../pages/cards"));
const ETLTab = lazy(() => import("../pages/etlTab"));
//No loadable found
// const TripBooking = lazy(() => import("../pages/"));
const Vendor = lazy(() => import("../pages/vendor"));
const Help = lazy(() => import("../pages/help/help"));
const UserTab = lazy(() => import("../pages/usertab"));
const Expense = lazy(() => import("../pages/expense"));
const Profile = lazy(() => import("../pages/profile"));
const Finance = lazy(() => import("../pages/finance"));
const InfoPage = lazy(() => import("../pages/infoPage"));
const ContactUs = lazy(() => import("../pages/contactUs"));
const TravelTab = lazy(() => import("../pages/traveltab"));
const ReportTab = lazy(() => import("../pages/reporttab"));
const Analytics = lazy(() => import("../pages/analytics"));
const WalletPage = lazy(() => import("../pages/walletPage"));
const AddExpense = lazy(() => import("../pages/addexpense"));
const LoadRequest = lazy(() => import("../pages/loadrequest"));
const BarCodeScanner = lazy(() => import("../pages/help/help"));
const AudioRecorder = lazy(() => import("../pages/recordaudio"));
const SharedExpense = lazy(() => import("../pages/sharedExpense"));
const ReportRequest = lazy(() => import("../pages/reportrequest"));
const DeletedUser = lazy(() => import("../pages/deletedUserList"));
const HappayProducts = lazy(() => import("../pages/happayProduct"));
const Vehicle = lazy(() => import("../pages/vehiclePages/vehicle"));
const AnalyticalView = lazy(() => import("../pages/analyticalView"));
const SmartXpense = lazy(() => import("../pages/smartXpense/index"));
const Administration = lazy(() => import("../pages/administration"));
const BulkHistoryUser = lazy(() => import("../pages/bulkHistoryList"));
const TravelRequest = lazy(() => import("../pages/travelrequestList"));
const AutomatedReport = lazy(() => import("../pages/AutomatedReport"));
const GenericWorkflow = lazy(() => import("../pages/genericworkflow"));
const PendingMoneyRequest = lazy(() => import("../pages/moneyrequest"));
const DraftExpenseExpense = lazy(() => import("../pages/draftExpense"));
const InitiateLoadMoney = lazy(() => import("../pages/initiateLoadmoney"));
const InitiatedCardLoad = lazy(() => import("../pages/initiatedCardLoad"));
const RecurringCardLoad = lazy(() => import("../pages/recurringCardLoad"));
const CreateRecurring = lazy(() => import("../pages/createrecurringload"));
const AdministrationTabs = lazy(() => import("../pages/administrationTabs"));
const BudgetContainerLodable = lazy(() => import("../pages/budgetContainer"));
const AddEditCRate = lazy(() => import("../pages/CurrencyRates/addEditCurrencyRate"));
const DefaultAutoContainerAction = lazy(() => import("../pages/defaultAutoContainer"));
const InitiateWalletLoad = lazy(() => import("../pages/bulkUsers/initiateWalletLoad"));
const InitiateWalletWithdraw = lazy(() => import("../pages/bulkUsers/initiateWalletWithdraw"));
const LoadCompanyWalletForPoolAccount = lazy(() =>
    import("../pages/loadPoolAccountPages/loadCompanyWallet")
);
const Allocation = lazy(() => import("../pages/allocation/allocation"))
//------------------- End Pages Import -------------------------------------//

//constants
const Split = lazy(() => import("../constants/split"));

//------------------- Start Components Import -------------------------------------//
const TestUI = lazy(() => import("../components/elements"));
const Gallery = lazy(() => import("../components/gallery/gallery"));
const Recharge = lazy(() => import("../components/recharge/recharge"));
const BulkBudget = lazy(() => import("../components/budget/bulkBudget"));
const Account = lazy(() => import("../components/loadaccount/loadaccount"));
const AppcenterConfig = lazy(() => import("../components/appcenterconfig"));
const LoadMoney = lazy(() => import("../components/loadaccount/loadmoney"));
const BulkUpload = lazy(() => import("../components/bulkEngine/bulkUpload"));
const RechargeTabs = lazy(() => import("../components/recharge/rechargetabs"));
const AccountTabs = lazy(() => import("../components/loadaccount/accounttabs"));
const AuditModule = lazy(() => import("../components/AuditModule/auditModule"));
const AddDelegation = lazy(() => import("../components/settings/adddelegation"));
const BulkApproval = lazy(() => import("../components/bulkEngine/bulkApproval"));
const MobileRecharge = lazy(() => import("../components/recharge/mobilerecharge"));
const BulkUploadNewUi = lazy(() => import("../components/bulkEngine/bulkUploadNewUi"));
const ReportTripDetails = lazy(() => import("../components/report/reporttripdetails"));
const AttachToExistingReport = lazy(() => import("../components/report/attachtoexisting"));
const BulkExpenseUpload = lazy(() => import("../components/bulkEngine/bulkExpenseUpload"));
const MoneyRequest = lazy(() => import("../components/moneyrequest/moneyrequestdialogue"));
const SettlementViaExcel = lazy(() => import("../components/settlement/settlementViaExcel"));
const CreateRecurringTransfer = lazy(() =>
    import("../components/loadaccount/createrecurringTransfers")
);
const RunningContainerTypeEF = lazy(() =>
    import("../components/genericContainerType/selectRunningContainer_ConTypeEF")
);
const ATMLocator = lazy(() => import("../components/wallet/atmLocatorWrapper"));

//------------------- End Components Import -------------------------------------//

//------------------- Start Support Import -------------------------------------//
// const RouteWrapper = lazy(() => import("./routeWrapper"));
const DisputeRedirect = lazy(() => import("./disputeRoute"));

//Wrapper supports
import RouteWrapper from "./routeWrapper";
import ProfileRoutes from "./profileRoutes";
import UserRoutes from "./userRoutes";
import FinanceRoutes from "./financeRoutes";
import LoadRequestRoutes from "./loadRequestRoutes";
import TravelRequestRoutes from "./travelRequestRoutes";
import ReportRequestRoutes from "./reportRequestRoutes";
import VehicleRoutes from "./vehicleRoutes";
import SmartXpenseRoutes from "./smartXpenseRoutes";

//------------------- End Support Import -------------------------------------//

//NOTE:  If you are adding any new <Route /> then add same in path.js

const DashboardRoutes = [
    <Route exact path="/dashboard" component={DashboardTab} />,

    <Route
        exact
        path={["/expense/addexpense", "/expense/addexpense/:tabId"]}
        component={AddExpense}
    />,

    <Route exact path="/expenses/dispute/:txnId" component={DisputeRedirect} />,
    <Route exact path="/expense" component={Expense} />,
    <Route exact path="/expense/draft" component={DraftExpenseExpense} />,
    <Route exact path="/expense/share" component={SharedExpense} />,

    <Route
        exact
        path={["/expense/split", "/expense/split/:txnId", "/expense/split/:txnId/:currency"]}
        component={Split}
    />,

    <Route
        exact
        path={[
            "/report",
            "/report/:reportTabs",
            "/report/:reportTabs/:viewId",
            "/report/:reportTabs/:viewId/:wallet",
            "/report/:tripId"
        ]}
        component={ReportTab}
    />,

    <Route exact path="/reporttripdetails" component={ReportTripDetails} />,

    <RouteWrapper
        exact
        path={["/users", "/users/:id", "/users/:id/*", "/users/:id/wallets/*"]}
        layout={InfoPage}
        routes={UserRoutes}
    />,

    <Route exact path="/home" component={HappayProducts} />,

    <Route exact path="/gallery" component={Gallery} />,

    <Route exact path="/recordaudio" component={AudioRecorder} />,

    <Route exact path="/barcodescanner" component={BarCodeScanner} />,

    <Route exact path={["/help", "/help/:getting"]} component={Help} />,

    <Route exact path="/contactUs" component={ContactUs} />,

    <Route
        exact
        path={["/containertype", "/containertype/:ct_id", "/containertype/:ct_id/:efId"]}
        component={RunningContainerTypeEF}
    />,
    <Route
        exact
        path={["/atmLocator"]}
        component={ATMLocator}
    />,
    <Route
        exact
        path={["/createrecurringload", "/createrecurringload/:id"]}
        component={CreateRecurring}
    />,

    <Route
        exact
        path={["/appcenter", "/appcenter/userconfig", "/appcenter/userconfig/:stp_id"]}
        component={AppcenterConfig}
    />,

    <Route
        exact
        path={[
            "/addexpensetoreport",
            "/addexpensetoreport/:tripId"
        ]} //   not working in prod also, redirecting to the previous vist page
        component={AttachToExistingReport}
    />,

    <Route exact path="/vendor" component={Vendor} />,

    <Route exact path="/am" component={AuditModule} />,

    <Redirect exact from="/administration" to="/administration/categories" />,
    <RouteWrapper
        exact
        path={[
            "/administration/:administrationTabs",
            "/administration/:administrationTabs/:eId",
            "/administration/:administrationTabs/:eId/:aId",
            "/administration/:administrationTabs/:eId/:aId/:sId",
            "/administration/:administrationTabs/:eId/:aId/:sId/:sid",
            "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid",
            "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId",
            "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId",
            "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId",
            "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId",
            "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId/:kId",
            "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId/:kId/:cId",
            "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId/:kId/:cId/:rId"
        ]}
        layout={Administration}
        routes={[
            <Route
                exact
                path={[
                    "/administration/:administrationTabs",
                    "/administration/:administrationTabs/:eId",
                    "/administration/:administrationTabs/:eId/:aId",
                    "/administration/:administrationTabs/:eId/:aId/:sId",
                    "/administration/:administrationTabs/:eId/:aId/:sId/:sid",
                    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid",
                    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId",
                    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId",
                    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId",
                    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId",
                    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId/:kId",
                    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId/:kId/:cId",
                    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId/:kId/:cId/:rId"
                ]}
                component={AdministrationTabs}
            />
        ]}
    />,

    <Route exact path="/profile/adddelegation" component={AddDelegation} />,

    // Profile Routes
    <RouteWrapper
        exact
        path={[
            "/profile/*",
            "/profile/constructCurrencyRange", // not able to test this path, getting some permission issue
            "/profile/constructCurrencyRange(:/id)" // I think this route is also wrong
        ]}
        layout={Profile}
        routes={ProfileRoutes}
    />,

    // Users Routes
    <RouteWrapper
        exact
        path={["/users", "/users/:id", "/users/:id/*", "/users/:id/wallets/*"]}
        layout={InfoPage}
        routes={UserRoutes}
    />,

    // don't know where we are using those wallet paths
    <Route
        exact
        path={[
            "/wallets",
            "/wallets/:walletTab",
            "/wallets/:walletTab/:walletSubTab",
            "/wallets/:walletTab/:walletSubTab/:mId"
        ]}
        component={WalletPage}
    />,

    <Route exact path="/moneyrequest" component={PendingMoneyRequest} />,

    <Route exact path="/banktransfer/initiate" component={LoadMoney} />,

    // Finance Routes
    <RouteWrapper
        exact
        path={[
            "/passbook",
            "/walletcontrol",
            "/settlements",
            "/currency",
            "/invoice",
            "/poolAccount",
            "/orgAccount",
            "/budget", // How to navigate this from UI?
            "/banktransfer",
            "/recurringtransfer",
            "/settlementEmployeeTabs/*",
            "/settlementTabs/*",
            "/currencyrates",
            "/currencyrates/:component"
        ]}
        layout={Finance}
        routes={FinanceRoutes}
    />,

    <Route path="/bulk/update/bulkSettlement" component={SettlementViaExcel} />,
    <Route
        exact
        path={["/budget", "/budget/:budgetTab", "/budget/:budgetTab/:id"]}
        component={BudgetContainerLodable}
    />,

    <Route exact path={"/bulkBudget"} component={BulkBudget} />,

    <Route
        exact
        path={[
            "/currencyrateoperation",
            "/currencyrateoperation/:crOperation",
            "/currencyrateoperation/:crOperation/:id"
        ]}
        component={AddEditCRate}
    />,
    <Route exact path="/poolAccount/loadWallet" component={LoadCompanyWalletForPoolAccount} />,
    <Route
        exact
        path={["/recurringtransferadd", "/recurringtransferadd/:id"]}
        component={CreateRecurringTransfer}
    />,

    <Route exact path={["/raisemoneyrequest/:wallet_id"]} component={MoneyRequest} />,

    <Route exact path={["/automatedreport", "/automatedreport/:id"]} component={AutomatedReport} />,

    <Route exact path={["/travel", "/travel/:id", "/travel/:id/:tripId"]} component={TravelTab} />,

    <Route exact path={["/etl", "/etl/:id"]} component={ETLTab} />,

    <Route exact path={["/cards", "/cards/:tabName"]} component={Cards} />,

    <Route exact path="/cardload_rq" component={InitiatedCardLoad} />,
    <Route exact path="/recurring_load" component={RecurringCardLoad} />,

    <Route
        exact
        path={[
            "/genericworkflow",
            "/genericworkflow/:id",
            "/genericworkflow/:id/:resource_id",
            "/genericworkflow/:id/:resource_id/:editType",
            "/genericworkflow/:id/:resource_id/:editType/:fromOthersTab"
        ]}
        component={GenericWorkflow}
    />,

    <Route exact path="/deleted_user" component={DeletedUser} />,
    <Route exact path="/bulk_history" component={BulkHistoryUser} />,

    <Route
        exact
        path={["/bulk", "/bulk/:mId", "/bulk/:mId/:oId", "/bulk/:mId/:oId/:stepId"]}
        component={BulkUpload}
    />,

    <Route
        exact
        path={["/bulkNew", "/bulkNew/:mId", "/bulkNew/:mId/:oId"]}
        component={BulkUploadNewUi}
    />,

    <Route
        exact
        path={[
            "/bulkexpense",
            "/bulkexpense/:mId",
            "/bulkexpense/:mId/:oId",
            "/bulkexpense/:mId/:oId/:stepId"
        ]}
        component={BulkExpenseUpload}
    />,

    <Route exact path={["/bulkapprove", "/bulkapprove/:id"]} component={BulkApproval} />,

    // Recharge Routes
    <RouteWrapper
        exact
        path="/recharge"
        layout={Recharge}
        routes={[
            <Route exact path={["/recharge/:rechargeTab"]} component={RechargeTabs} />,
            <Route exact component={MobileRecharge} /> // Don't know where we are using
        ]}
    />,

    // Analytics Routes
    <Redirect exact from="/analytics" to="/analytics/mydashboard" />,
    <RouteWrapper
        exact
        path={["/analytics", "/analytics/*"]}
        layout={Analytics}
        routes={[
            <Route exact path={["/analytics", "/analytics/:tab"]} component={AnalyticalView} />
        ]}
    />,

    // Account Routes
    <RouteWrapper
        exact
        path="/account"
        layout={Account}
        routes={[
            <Route
                exact
                path={["/account/:accountTab", "/account/:accountTab/:mId"]}
                component={AccountTabs}
            />,
            <Route exact component={LoadMoney} />
        ]}
    />,

    // <Route
    //     exact
    //     path={["/bookings", "/bookings/:type", "/bookings/:type/:it_id"]}
    //     component={TripBooking}
    // />,

    <Route exact path="/autocontaineraction" component={DefaultAutoContainerAction} />,

    <Route exact path="/autocontaineractionV2" component={DefaultAutoContainerAction} />,

    <Route exact path="/testUI" component={TestUI} />,

    // User Routes
    <RouteWrapper
        exact
        path={["/user/:userTabs", "/user/:userTabs/:stp_id", "/user/:userTabs/:stp_id/:type"]}
        layout={UserTab}
        routes={[
            <Route
                exact
                path={[
                    "/user/:userTabs",
                    "/user/:userTabs/:stp_id",
                    "/user/:userTabs/:stp_id/:type"
                ]}
                component={UserTab}
            />
        ]}
    />,

    <Route
        exact
        path={[
            "/initiatesingle",
            "/initiatesingle/:identifier",
            "/initiatesingle/:identifier/:amount",
            "/initiatesingle/:identifier/:amount/:userId",
            "/initiatesingle/:identifier/:amount/:userId/:walletType",
            "/initiatesingle/:identifier/:amount/:userId/:walletType/:initiatMode"
        ]}
        component={InitiateLoadMoney}
    />,

    <Route
        exact
        path={[
            "/initiate_wallet_load",
            "/initiate_wallet_load/:no_of_users",
            "/initiate_wallet_load/:no_of_users/:totalUsers",
            "/initiate_wallet_load/:no_of_users/:totalUsers/:walletValue"
        ]}
        component={InitiateWalletLoad}
    />,

    <Route
        exact
        path={[
            "/initiate_wallet_withdraw",
            "/initiate_wallet_withdraw/:no_of_users",
            "/initiate_wallet_withdraw/:no_of_users/:totalUsers",
            "/initiate_wallet_withdraw/:no_of_users/:totalUsers/:walletValue"
        ]}
        component={InitiateWalletWithdraw}
    />,

    // LoadRequest Routes
    <RouteWrapper
        exact
        path={[
            "/history/moneyrequest",
            "/cardload_hist",
            "/pending/moneyrequest",
            "/pending/cardload",
            "/others/allmoneyrequest"
        ]}
        layout={LoadRequest}
        routes={LoadRequestRoutes}
    />,

    // Travel Request Routes
    <RouteWrapper
        exact
        path={["/history/travel", "/pending/travel", "/others/alltravel"]}
        layout={TravelRequest}
        routes={TravelRequestRoutes}
    />,

    // Report Request Routes
    <RouteWrapper
        exact
        path={["/history/report", "/pending/report", "/others/allreport"]}
        layout={ReportRequest}
        routes={ReportRequestRoutes}
    />,

    // Vehicle Routes
    <RouteWrapper
        exact
        path={[
            "/vehicleList",
            "/vehicleCardLimit",
            "/vehicleList/addNewVehicles",
            "/vehicleList/editVehicle",
            "/vehicleCardLimit/vehiclesCurrentLimit"
        ]}
        layout={Vehicle}
        routes={VehicleRoutes}
    />,

    // Smart Xpense Routes
    <Redirect exact from="/smartxpense/" to="/xpendite/" />,
    <RouteWrapper exact path={["/xpendite/*"]} layout={SmartXpense} routes={SmartXpenseRoutes} />,
    <Route exact path="/allocation" component={Allocation} />,
];
export default DashboardRoutes;
